//@flow
import styled from 'styled-components';

export const ArticleFeedCardContainer: any = styled.div`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.accent1LL};
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.15s ease;
  margin-bottom: 14px;
  padding: 0 20px;

  ${({ theme, plus }) => plus && `background-color: ${theme.plus.grey};`}
`;
